'use client';

import { cn } from '@lib/utils/cn';
import { PropsWithChildren } from 'react';

import { CardVariant } from '../types';

interface CardProps {
  variant?: CardVariant;
  rounded?: string;
  className?: string;
  overflowHidden?: boolean;
  style?: React.CSSProperties;
}

const BG: Record<string, string> = {
  primary: 'bg-custom-base-inverse-primary',
  secondary: 'bg-surface-base-secondary',
  darkness: 'bg-[#353B40]',
  blur: 'bg-surface-base-blur',
  subtle: 'bg-surface-base-subtle',
  tertiary: 'bg-surface-base-tertiary',
  transparent: 'transparent',
};

export const Card = ({
  variant = 'secondary',
  rounded = '20',
  className,
  overflowHidden,
  children,
  style,
}: PropsWithChildren<CardProps>) => {
  return (
    <div
      style={style}
      className={cn(
        'box-border h-full w-full',
        `rounded-[${rounded}px]`,
        overflowHidden && 'overflow-hidden',
        BG[variant],
        className,
      )}
    >
      {children}
    </div>
  );
};
